// Reducer

import { FAILURE, REQUEST, SUCCESS } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './actions';
import { GlobalState, initialState } from './state';

import { GlobalConf } from './../../domain/GlobalConf';

export default (state: GlobalState = initialState, action): GlobalState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_SELLING_POINTS):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_SELLING_POINTS): {
      return {
        ...state,
        loading: false,
        sellingPoints: action.payload.data,
      };
    }

    case FAILURE(ACTION_TYPES.GET_SELLING_POINTS): {
      return {
        ...initialState,
        loading: false,
      };
    }
    case REQUEST(ACTION_TYPES.GET_CONF):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CONF):
      return {
        ...state,
        configuration: action.payload.data as GlobalConf,
        isReady: true,
      };

    case ACTION_TYPES.GET_AVATAR:
      return {
        ...state,
        avatar: action.payload,
      };

    case ACTION_TYPES.GET_AVATAR_LIST:
      return {
        ...state,
        lstAvatars: action.payload,
      };

    case ACTION_TYPES.SET_DEVICE_TYPE:
      return {
        ...state,
        deviceType: action.payload,
      };

    default:
      return state;
  }
};
